import React from 'react';
import {SafeAreaView as RNWSafeAreaView} from 'react-native';

const MOCK_INITIAL_METRICS = {
  frame: {
    width: 320,
    height: 640,
    x: 0,
    y: 0,
  },
  insets: {
    left: 0,
    right: 0,
    bottom: 0,
    top: 0,
  },
};

const SafeAreaInsetsContext = React.createContext(MOCK_INITIAL_METRICS.insets);
const SafeAreaFrameContext = React.createContext(MOCK_INITIAL_METRICS.frame);

export const SafeAreaProvider = ({children, initialMetrics}) => (
  <SafeAreaFrameContext.Provider
    value={initialMetrics?.frame ?? MOCK_INITIAL_METRICS.frame}>
    <SafeAreaInsetsContext.Provider
      value={initialMetrics?.insets ?? MOCK_INITIAL_METRICS.insets}>
      {children}
    </SafeAreaInsetsContext.Provider>
  </SafeAreaFrameContext.Provider>
);

// Delegate to react-native-web's SafeAreaView (env(safe-area-inset-*)
// padding) so shared mobile screens migrated to safe-area-context render on
// web exactly as they did with the RN import. A raw div can't take RN
// StyleSheet styles; `edges`/`mode` are native-only props — strip them.
export const SafeAreaView = ({children, edges: _edges, mode: _mode, ...rest}) => (
  <RNWSafeAreaView {...rest}>{children}</RNWSafeAreaView>
);

export const useSafeAreaInsets = () => MOCK_INITIAL_METRICS.insets;

export const withSafeAreaInsets = Component => props => (
  <Component {...props} insets={MOCK_INITIAL_METRICS.insets} />
);

export { SafeAreaInsetsContext, SafeAreaFrameContext };
export const initialWindowMetrics = MOCK_INITIAL_METRICS;

export default {
  SafeAreaProvider,
  SafeAreaInsetsContext,
  SafeAreaFrameContext,
  SafeAreaView,
  initialWindowMetrics: MOCK_INITIAL_METRICS,
  useSafeAreaInsets,
  withSafeAreaInsets,
};
